import {
    Box,
    LinearProgress,
    Typography,
} from "@mui/material";

import { GraphQLLinkRegistryDAOFactory } from "../../../lib/linkRegistry/dao/GraphQLLinkRegistryDAOFactory";
import { LinkRegistryDAO } from "../../../lib/linkRegistry/dao/LinkRegistryDAO";
import { PropertyManagerLinkRegistryForm } from "../../../components/linkRegistry/propertymanager/PropertyManagerLinkRegistryForm";
import { QRCodeScannerToggle } from "../../../components/linkRegistry/scanner/QRCodeScannerToggle";
import { RoundedCard } from "../../../componentsV2/misc/RoundedCard";
import globalStyle from "../../../assets/style/globalStyle";
import { usePageDefaultStyle } from "../../../assets/style/usePageDefaultStyle";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { useState } from "react";

type PropertyManagerLinkSetUpPageParams = {
    id: string;
};

const linkRegistryDAO: LinkRegistryDAO = GraphQLLinkRegistryDAOFactory.getInstance();

export const PropertyManagerLinkSetUpPage = () => {
    const { id } = useParams<PropertyManagerLinkSetUpPageParams>();
    const { data, refetch, isLoading } = useQuery({
        queryKey: ["linkRegistry", id],
        queryFn: async () => {
            return await linkRegistryDAO.getById(id);
        }
    });
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
    const [hasFormChanged, setHasFormChanged] = useState<boolean>(false);

    const globalClasses = globalStyle();
    const { pageDefaultStyle } = usePageDefaultStyle();

    return (
        <Box sx={pageDefaultStyle} key={id}>
            <Box className={globalClasses.managerLayout}>
                <Typography variant="h4">
                    QR Code Set Up
                </Typography>
                <RoundedCard>
                    {isLoading ? <LinearProgress /> : (
                        <PropertyManagerLinkRegistryForm
                            id={id}
                            linkRegistry={data}
                            onSaved={async () => { await refetch(); }}
                            isSubmitted={isSubmitted}
                            setIsSubmitted={setIsSubmitted}
                            setHasFormChanged={setHasFormChanged}
                        />
                    )}
                </RoundedCard>
                {!isSubmitted && (
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <Typography variant="body2">Need to configure a different QR code?</Typography>
                        <QRCodeScannerToggle variant="text" sx={{ px: 0 }} showWarning={hasFormChanged}>
                            Click here to scan a new code
                        </QRCodeScannerToggle>
                    </Box>
                )}
            </Box>
        </Box>
    );
};